export default __webpack_public_path__ + "static/media/3.a7bc145d.jpg";